<template>
  <!-- 404界面 -->
  <div class="notfount">
    <div class="box">
      <img src="../assets/404.png" alt>
      <div style="margin-top:10px;">
        <a href="/home">
          <el-button type="primary">回首页</el-button>
        </a>
      </div>
    </div>
  </div>
</template>
<style>
.notfount {
  width: 580px;
  height: 230px;
  background-color: #fff;
  margin: -140px 0 0 -270px;
  position: absolute;
  left: 50%;
  top: 40%;
  text-align: center;
  /* background-color: #f3f3f3; */
}
</style>
<script>
export default {
  name: "notfount",
  created() {
    this.$emit("public_header", false);
    this.$emit("public_nav", false);
    this.$emit("public_footer", false);
  }
};
</script>







// WEBPACK FOOTER //
// src/components/notfount.vue